import { useAppSelector } from '../../../app/hooks'
import { InitState } from '../../../redux/reducers/root/initialState'
import { useFeatureSwitch } from '../../../utils/features/FeatureSwitchContext'
import { FeatureSwitch } from '../../../utils/features/featureSwitches'

export function useIsDepositGuaranteeEnabled() {
  const { isActive: isDepositGuaranteeFeatureEnabled } = useFeatureSwitch(
    FeatureSwitch.PPA_13204_RENT_APARTMENT_HOUSE_CL_DEPOSIT_GUARANTEE
  )
  const isDepositGuaranteeFlowOptionEnabled = useAppSelector(
    (state: InitState) => state.flowFeature.flowInformation.options?.depositGuaranteeEnabled === true
  )

  return isDepositGuaranteeFeatureEnabled && isDepositGuaranteeFlowOptionEnabled
}
